module.exports = __webpack_public_path__ + "a05448056df150016bb939189ea1202b.png";